import React, { Component } from 'react'
import {Container, Row, Col} from 'reactstrap';
import { createStore, applyMiddleware  } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { createLogger } from 'redux-logger'
import {Provider} from 'react-redux'
import {
  BrowserRouter as Router,
  Route,
  Link
} from 'react-router-dom'

import moment from 'moment';
import 'moment/locale/pl';

//app components
import './App.css'
import AppMenu from './containers/AppMenu'
//import AppBody from './containers/AppBody'
import AppLoginWidget from './containers/AppLoginWidget'
import Home from './Home'
import ReportRes from './ReportRes'
import Refunds from './Refunds'
import Search from './Search'
import Refund from './Refund'
import Sales from './Sales'

import agentapp from './reducers'

moment.locale('pl')

let middleware = [thunkMiddleware]

if (process.env.NODE_ENV !== 'production') {  
  //let loggerMiddleware = require('redux-logger')  
  const loggerMiddleware = createLogger()
  middleware = [...middleware, loggerMiddleware]  
}

let store=createStore(agentapp,
  {},
  applyMiddleware(...middleware)
);

class App extends Component {
// eslint-disable-next-line
  constructor (props) {
    super(props)
    //this.handleChangeMenu = this.handleChangeMenu.bind(this);    
  }

  // handleChangeMenu(event) {
  //   //event.preventDefault();
  //   alert("Zmiana menu");
  //   //this.props.onCancel();
  // }
  //<Router onChange={this.handleChangeMenu}>      
  render() {
    return (
      <Provider store={store}>        
        <Router>              
          <div className="App">
            <Container fluid className="App-header">
              <Row className="no-gutters">                  
                <Col xs="2">
                  <Link to="/"><img src="images/logo.png" alt="logo" className="App-logo" /></Link>
                </Col>
                <Col xs="10">
                  <Row>                  
                    <Col xs="auto" className="ml-auto">
                    <h1>Moduł Agenta systemu Moj-Bus.pl</h1>              
                    </Col>
                  </Row>
                  <Row>
                    <Col xs="auto" className="ml-auto">
                    <AppLoginWidget />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs="auto" className="ml-auto">
                    <AppMenu/>
                    </Col>
                  </Row>                  
                </Col>
              </Row>      
            </Container>                          
            <div className="App-body">              
              <Route exact path="/" component={Home}/>
              <Route path="/reservations" component={ReportRes}/>
              <Route path="/refunds" component={Refunds}/>
              <Route path="/sales" component={Sales}/>
              <Route path="/search" component={Search}/>
              <Route path="/refund/:idReservation" component={Refund}/>
            </div>                        
          </div>
        </Router>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js